<template>
	<b-container>
			<b-row class="mx-0">
					<b-col cols="12">
							<StepProgress 
									:steps="mySteps" 
									:current-step="currentStep" 
									icon-class="fa fa-check" 
									active-color="#2dce89"
									:active-thickness="3"
									:passive-thickness="3"
									:line-thickness="3"
							></StepProgress>
					</b-col>
			</b-row>
	</b-container>
</template>
<script>
import StepProgress from 'vue-step-progress'

export default {
	props:['step_status'],
	components: {
			StepProgress
	},
	data() {
			return {
					mySteps: [
							'Convert to Cases',
							'Pending Submission',
							'Submitted',
							'Pending Accept',
							'Acceptance Done',
							'Completed',
					],
					currentStep: 1,
			}
	},
	created(){

		
			if(this.step_status == 'Pending Submission'){
				this.currentStep = 1;
			}else if(this.step_status == 'Submitted'){
				this.currentStep = 2;
			}else if(this.step_status == 'Pending Accept'){
				this.currentStep = 3;
			}else if(this.step_status == 'Acceptance Done'){
				this.currentStep = 4;
			}else if(this.step_status == 'Completed'){
				this.currentStep = 5;
			}else {
				this.currentStep = 0;
			}
	},
}
</script>